export enum WorkStatus {
    Unknown = "Ukjent",
    InProgress = "Pågår",
    Completed = "Fullført"
}